import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type.ts";
import type { Notebook } from "@notebook/domain/models/notebook.model";
import type { NotebookRepository } from "@notebook/domain/repositories/notebook.repository";
import { notebookTypes } from "@notebook/notebook-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotebookGetByIdUseCase {
    constructor(
        @inject(notebookTypes.repositories.NotebookRepository)
        private readonly notebookRepository: NotebookRepository,
    ) {}

    async execute(notebookId: string): Promise<Nullable<Notebook>> {
        const notebookResult =
            await this.notebookRepository.fetchById(notebookId);

        if (notebookResult.isErr()) {
            ToastManagerRepository.error(notebookResult.error.message);
        }
        return notebookResult.match(
            (notebook) => notebook,
            () => null,
        );
    }
}
